import type { DatePickerDateType } from '@pba/react-components';
import { type PostContentObjectDetail, createPostContentObjectDetail } from 'models';
import { useMutation } from 'query';
import type { AttahcmentsInputUploadFile } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix
import { useContentObjectCache } from 'features/feed/queries/cache';
import { editPost } from 'features/posts';

export type UpdatePostMutationData = {
  post: PostRequestData;
  postId: string;
};

type PostRequestData = {
  attachments?: { fileList: AttahcmentsInputUploadFile[] };
  htmlContent: string;
  programTopicId: string;
  publishAt: DatePickerDateType;
  textContent?: string;
  title: string;
  todoDueDate: DatePickerDateType;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const useUpdatePostMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<PostContentObjectDetail, UpdatePostMutationData>({
    async mutationFn({ post, postId }) {
      const response = await editPost({
        body: {
          /* eslint-disable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
          attachments: post.attachments?.fileList.map((attachment) => ({ id: attachment.response.id })),
          html_content: post.htmlContent,
          program_topic_id: post.programTopicId,
          publish_at: post.publishAt.toISOString(),
          text_content: post.textContent,
          title: post.title,
          todo_due_date: post.todoDueDate.toISOString(),
        },
        routeParams: { id: postId },
        /* eslint-enable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
      });

      return createPostContentObjectDetail(response.data);
    },
    onSuccess(data) {
      cache.replace(data);
    },
  });
};
